/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InscriptionSuccessRouteImport } from './routes/inscription-success'
import { Route as InscriptionStripeUnknownRouteImport } from './routes/inscription-stripe-unknown'
import { Route as InscriptionRouteImport } from './routes/inscription'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ConnexionRouteImport } from './routes/connexion'
import { Route as ConfirmInvitationRouteImport } from './routes/confirm-invitation'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as FactureRouteRouteImport } from './routes/facture/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as ParentIdRouteImport } from './routes/parent.$id'
import { Route as LinkParentIdRouteImport } from './routes/link/$parentId'
import { Route as FactureInvoiceIdRouteImport } from './routes/facture/$invoiceId'
import { Route as AdminStudentsRouteRouteImport } from './routes/admin/students/route'
import { Route as AdminRemindersRouteRouteImport } from './routes/admin/reminders/route'
import { Route as AdminPaymentsRouteRouteImport } from './routes/admin/payments/route'
import { Route as AdminParentsRouteRouteImport } from './routes/admin/parents/route'
import { Route as AdminNewEnrollmentsRouteRouteImport } from './routes/admin/new-enrollments/route'
import { Route as LinkParentIdIndexRouteImport } from './routes/link/$parentId/index'
import { Route as AdminTeachersIndexRouteImport } from './routes/admin/teachers/index'
import { Route as AdminStudentsIndexRouteImport } from './routes/admin/students/index'
import { Route as AdminSmsIndexRouteImport } from './routes/admin/sms/index'
import { Route as AdminRemindersIndexRouteImport } from './routes/admin/reminders/index'
import { Route as AdminPaymentsIndexRouteImport } from './routes/admin/payments/index'
import { Route as AdminParentsIndexRouteImport } from './routes/admin/parents/index'
import { Route as AdminNewEnrollmentsIndexRouteImport } from './routes/admin/new-enrollments/index'
import { Route as AdminInvoicesIndexRouteImport } from './routes/admin/invoices/index'
import { Route as AdminInscriptionsIndexRouteImport } from './routes/admin/inscriptions/index'
import { Route as AdminCoursesIndexRouteImport } from './routes/admin/courses/index'
import { Route as AdminAttendanceIndexRouteImport } from './routes/admin/attendance/index'
import { Route as LinkParentIdProfilRouteImport } from './routes/link/$parentId/profil'
import { Route as LinkParentIdPaymentsRouteImport } from './routes/link/$parentId/payments'
import { Route as LinkParentIdPaymentReturnCheckoutRouteImport } from './routes/link/$parentId/payment-return-checkout'
import { Route as LinkParentIdPaymentMethodsRouteImport } from './routes/link/$parentId/payment-methods'
import { Route as LinkParentIdPayRouteImport } from './routes/link/$parentId/pay'
import { Route as LinkParentIdInvoicesRouteImport } from './routes/link/$parentId/invoices'
import { Route as AdminTeachersIdRouteImport } from './routes/admin/teachers/$id'
import { Route as AdminStudentsIdRouteImport } from './routes/admin/students/$id'
import { Route as AdminPaymentsIdRouteImport } from './routes/admin/payments/$id'
import { Route as AdminParentsImportRouteImport } from './routes/admin/parents/import'
import { Route as AdminParentsIdRouteImport } from './routes/admin/parents/$id'
import { Route as AdminNewEnrollmentsIdRouteImport } from './routes/admin/new-enrollments/$id'
import { Route as AdminInvoicesPreviewRouteImport } from './routes/admin/invoices/preview'
import { Route as AdminInvoicesIdRouteImport } from './routes/admin/invoices/$id'
import { Route as AdminCoursesIdRouteImport } from './routes/admin/courses/$id'
import { Route as AdminConfigurationUsersRouteImport } from './routes/admin/configuration/users'
import { Route as AdminConfigurationNotificationsRouteImport } from './routes/admin/configuration/notifications'
import { Route as AdminConfigurationInvitationsRouteImport } from './routes/admin/configuration/invitations'
import { Route as AdminConfigurationCronTasksRouteImport } from './routes/admin/configuration/cron-tasks'
import { Route as LinkParentIdPaymentsIndexRouteImport } from './routes/link/$parentId/payments/index'
import { Route as LinkParentIdInvoicesIndexRouteImport } from './routes/link/$parentId/invoices/index'
import { Route as LinkParentIdPaymentsPaymentIdRouteImport } from './routes/link/$parentId/payments/$paymentId'
import { Route as LinkParentIdInvoicesInvoiceIdRouteImport } from './routes/link/$parentId/invoices/$invoiceId'
import { Route as AdminInvoicesCorrectIdRouteImport } from './routes/admin/invoices/correct.$id'

const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InscriptionSuccessRoute = InscriptionSuccessRouteImport.update({
  id: '/inscription-success',
  path: '/inscription-success',
  getParentRoute: () => rootRouteImport,
} as any)
const InscriptionStripeUnknownRoute =
  InscriptionStripeUnknownRouteImport.update({
    id: '/inscription-stripe-unknown',
    path: '/inscription-stripe-unknown',
    getParentRoute: () => rootRouteImport,
  } as any)
const InscriptionRoute = InscriptionRouteImport.update({
  id: '/inscription',
  path: '/inscription',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnexionRoute = ConnexionRouteImport.update({
  id: '/connexion',
  path: '/connexion',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmInvitationRoute = ConfirmInvitationRouteImport.update({
  id: '/confirm-invitation',
  path: '/confirm-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const FactureRouteRoute = FactureRouteRouteImport.update({
  id: '/facture',
  path: '/facture',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const ParentIdRoute = ParentIdRouteImport.update({
  id: '/parent/$id',
  path: '/parent/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LinkParentIdRoute = LinkParentIdRouteImport.update({
  id: '/link/$parentId',
  path: '/link/$parentId',
  getParentRoute: () => rootRouteImport,
} as any)
const FactureInvoiceIdRoute = FactureInvoiceIdRouteImport.update({
  id: '/$invoiceId',
  path: '/$invoiceId',
  getParentRoute: () => FactureRouteRoute,
} as any)
const AdminStudentsRouteRoute = AdminStudentsRouteRouteImport.update({
  id: '/students',
  path: '/students',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRemindersRouteRoute = AdminRemindersRouteRouteImport.update({
  id: '/reminders',
  path: '/reminders',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPaymentsRouteRoute = AdminPaymentsRouteRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AdminRoute,
} as any)
const AdminParentsRouteRoute = AdminParentsRouteRouteImport.update({
  id: '/parents',
  path: '/parents',
  getParentRoute: () => AdminRoute,
} as any)
const AdminNewEnrollmentsRouteRoute =
  AdminNewEnrollmentsRouteRouteImport.update({
    id: '/new-enrollments',
    path: '/new-enrollments',
    getParentRoute: () => AdminRoute,
  } as any)
const LinkParentIdIndexRoute = LinkParentIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LinkParentIdRoute,
} as any)
const AdminTeachersIndexRoute = AdminTeachersIndexRouteImport.update({
  id: '/teachers/',
  path: '/teachers/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStudentsIndexRoute = AdminStudentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminStudentsRouteRoute,
} as any)
const AdminSmsIndexRoute = AdminSmsIndexRouteImport.update({
  id: '/sms/',
  path: '/sms/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRemindersIndexRoute = AdminRemindersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRemindersRouteRoute,
} as any)
const AdminPaymentsIndexRoute = AdminPaymentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminPaymentsRouteRoute,
} as any)
const AdminParentsIndexRoute = AdminParentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminParentsRouteRoute,
} as any)
const AdminNewEnrollmentsIndexRoute =
  AdminNewEnrollmentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminNewEnrollmentsRouteRoute,
  } as any)
const AdminInvoicesIndexRoute = AdminInvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInscriptionsIndexRoute = AdminInscriptionsIndexRouteImport.update({
  id: '/inscriptions/',
  path: '/inscriptions/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCoursesIndexRoute = AdminCoursesIndexRouteImport.update({
  id: '/courses/',
  path: '/courses/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAttendanceIndexRoute = AdminAttendanceIndexRouteImport.update({
  id: '/attendance/',
  path: '/attendance/',
  getParentRoute: () => AdminRoute,
} as any)
const LinkParentIdProfilRoute = LinkParentIdProfilRouteImport.update({
  id: '/profil',
  path: '/profil',
  getParentRoute: () => LinkParentIdRoute,
} as any)
const LinkParentIdPaymentsRoute = LinkParentIdPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => LinkParentIdRoute,
} as any)
const LinkParentIdPaymentReturnCheckoutRoute =
  LinkParentIdPaymentReturnCheckoutRouteImport.update({
    id: '/payment-return-checkout',
    path: '/payment-return-checkout',
    getParentRoute: () => LinkParentIdRoute,
  } as any)
const LinkParentIdPaymentMethodsRoute =
  LinkParentIdPaymentMethodsRouteImport.update({
    id: '/payment-methods',
    path: '/payment-methods',
    getParentRoute: () => LinkParentIdRoute,
  } as any)
const LinkParentIdPayRoute = LinkParentIdPayRouteImport.update({
  id: '/pay',
  path: '/pay',
  getParentRoute: () => LinkParentIdRoute,
} as any)
const LinkParentIdInvoicesRoute = LinkParentIdInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => LinkParentIdRoute,
} as any)
const AdminTeachersIdRoute = AdminTeachersIdRouteImport.update({
  id: '/teachers/$id',
  path: '/teachers/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStudentsIdRoute = AdminStudentsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminStudentsRouteRoute,
} as any)
const AdminPaymentsIdRoute = AdminPaymentsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminPaymentsRouteRoute,
} as any)
const AdminParentsImportRoute = AdminParentsImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AdminParentsRouteRoute,
} as any)
const AdminParentsIdRoute = AdminParentsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminParentsRouteRoute,
} as any)
const AdminNewEnrollmentsIdRoute = AdminNewEnrollmentsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminNewEnrollmentsRouteRoute,
} as any)
const AdminInvoicesPreviewRoute = AdminInvoicesPreviewRouteImport.update({
  id: '/invoices/preview',
  path: '/invoices/preview',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInvoicesIdRoute = AdminInvoicesIdRouteImport.update({
  id: '/invoices/$id',
  path: '/invoices/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCoursesIdRoute = AdminCoursesIdRouteImport.update({
  id: '/courses/$id',
  path: '/courses/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminConfigurationUsersRoute = AdminConfigurationUsersRouteImport.update({
  id: '/configuration/users',
  path: '/configuration/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminConfigurationNotificationsRoute =
  AdminConfigurationNotificationsRouteImport.update({
    id: '/configuration/notifications',
    path: '/configuration/notifications',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminConfigurationInvitationsRoute =
  AdminConfigurationInvitationsRouteImport.update({
    id: '/configuration/invitations',
    path: '/configuration/invitations',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminConfigurationCronTasksRoute =
  AdminConfigurationCronTasksRouteImport.update({
    id: '/configuration/cron-tasks',
    path: '/configuration/cron-tasks',
    getParentRoute: () => AdminRoute,
  } as any)
const LinkParentIdPaymentsIndexRoute =
  LinkParentIdPaymentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LinkParentIdPaymentsRoute,
  } as any)
const LinkParentIdInvoicesIndexRoute =
  LinkParentIdInvoicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LinkParentIdInvoicesRoute,
  } as any)
const LinkParentIdPaymentsPaymentIdRoute =
  LinkParentIdPaymentsPaymentIdRouteImport.update({
    id: '/$paymentId',
    path: '/$paymentId',
    getParentRoute: () => LinkParentIdPaymentsRoute,
  } as any)
const LinkParentIdInvoicesInvoiceIdRoute =
  LinkParentIdInvoicesInvoiceIdRouteImport.update({
    id: '/$invoiceId',
    path: '/$invoiceId',
    getParentRoute: () => LinkParentIdInvoicesRoute,
  } as any)
const AdminInvoicesCorrectIdRoute = AdminInvoicesCorrectIdRouteImport.update({
  id: '/invoices/correct/$id',
  path: '/invoices/correct/$id',
  getParentRoute: () => AdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/facture': typeof FactureRouteRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/confirm-invitation': typeof ConfirmInvitationRoute
  '/connexion': typeof ConnexionRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/inscription': typeof InscriptionRoute
  '/inscription-stripe-unknown': typeof InscriptionStripeUnknownRoute
  '/inscription-success': typeof InscriptionSuccessRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify': typeof VerifyRoute
  '/admin/new-enrollments': typeof AdminNewEnrollmentsRouteRouteWithChildren
  '/admin/parents': typeof AdminParentsRouteRouteWithChildren
  '/admin/payments': typeof AdminPaymentsRouteRouteWithChildren
  '/admin/reminders': typeof AdminRemindersRouteRouteWithChildren
  '/admin/students': typeof AdminStudentsRouteRouteWithChildren
  '/facture/$invoiceId': typeof FactureInvoiceIdRoute
  '/link/$parentId': typeof LinkParentIdRouteWithChildren
  '/parent/$id': typeof ParentIdRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/configuration/cron-tasks': typeof AdminConfigurationCronTasksRoute
  '/admin/configuration/invitations': typeof AdminConfigurationInvitationsRoute
  '/admin/configuration/notifications': typeof AdminConfigurationNotificationsRoute
  '/admin/configuration/users': typeof AdminConfigurationUsersRoute
  '/admin/courses/$id': typeof AdminCoursesIdRoute
  '/admin/invoices/$id': typeof AdminInvoicesIdRoute
  '/admin/invoices/preview': typeof AdminInvoicesPreviewRoute
  '/admin/new-enrollments/$id': typeof AdminNewEnrollmentsIdRoute
  '/admin/parents/$id': typeof AdminParentsIdRoute
  '/admin/parents/import': typeof AdminParentsImportRoute
  '/admin/payments/$id': typeof AdminPaymentsIdRoute
  '/admin/students/$id': typeof AdminStudentsIdRoute
  '/admin/teachers/$id': typeof AdminTeachersIdRoute
  '/link/$parentId/invoices': typeof LinkParentIdInvoicesRouteWithChildren
  '/link/$parentId/pay': typeof LinkParentIdPayRoute
  '/link/$parentId/payment-methods': typeof LinkParentIdPaymentMethodsRoute
  '/link/$parentId/payment-return-checkout': typeof LinkParentIdPaymentReturnCheckoutRoute
  '/link/$parentId/payments': typeof LinkParentIdPaymentsRouteWithChildren
  '/link/$parentId/profil': typeof LinkParentIdProfilRoute
  '/admin/attendance': typeof AdminAttendanceIndexRoute
  '/admin/courses': typeof AdminCoursesIndexRoute
  '/admin/inscriptions': typeof AdminInscriptionsIndexRoute
  '/admin/invoices': typeof AdminInvoicesIndexRoute
  '/admin/new-enrollments/': typeof AdminNewEnrollmentsIndexRoute
  '/admin/parents/': typeof AdminParentsIndexRoute
  '/admin/payments/': typeof AdminPaymentsIndexRoute
  '/admin/reminders/': typeof AdminRemindersIndexRoute
  '/admin/sms': typeof AdminSmsIndexRoute
  '/admin/students/': typeof AdminStudentsIndexRoute
  '/admin/teachers': typeof AdminTeachersIndexRoute
  '/link/$parentId/': typeof LinkParentIdIndexRoute
  '/admin/invoices/correct/$id': typeof AdminInvoicesCorrectIdRoute
  '/link/$parentId/invoices/$invoiceId': typeof LinkParentIdInvoicesInvoiceIdRoute
  '/link/$parentId/payments/$paymentId': typeof LinkParentIdPaymentsPaymentIdRoute
  '/link/$parentId/invoices/': typeof LinkParentIdInvoicesIndexRoute
  '/link/$parentId/payments/': typeof LinkParentIdPaymentsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/facture': typeof FactureRouteRouteWithChildren
  '/confirm-invitation': typeof ConfirmInvitationRoute
  '/connexion': typeof ConnexionRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/inscription': typeof InscriptionRoute
  '/inscription-stripe-unknown': typeof InscriptionStripeUnknownRoute
  '/inscription-success': typeof InscriptionSuccessRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify': typeof VerifyRoute
  '/facture/$invoiceId': typeof FactureInvoiceIdRoute
  '/parent/$id': typeof ParentIdRoute
  '/admin': typeof AdminIndexRoute
  '/admin/configuration/cron-tasks': typeof AdminConfigurationCronTasksRoute
  '/admin/configuration/invitations': typeof AdminConfigurationInvitationsRoute
  '/admin/configuration/notifications': typeof AdminConfigurationNotificationsRoute
  '/admin/configuration/users': typeof AdminConfigurationUsersRoute
  '/admin/courses/$id': typeof AdminCoursesIdRoute
  '/admin/invoices/$id': typeof AdminInvoicesIdRoute
  '/admin/invoices/preview': typeof AdminInvoicesPreviewRoute
  '/admin/new-enrollments/$id': typeof AdminNewEnrollmentsIdRoute
  '/admin/parents/$id': typeof AdminParentsIdRoute
  '/admin/parents/import': typeof AdminParentsImportRoute
  '/admin/payments/$id': typeof AdminPaymentsIdRoute
  '/admin/students/$id': typeof AdminStudentsIdRoute
  '/admin/teachers/$id': typeof AdminTeachersIdRoute
  '/link/$parentId/pay': typeof LinkParentIdPayRoute
  '/link/$parentId/payment-methods': typeof LinkParentIdPaymentMethodsRoute
  '/link/$parentId/payment-return-checkout': typeof LinkParentIdPaymentReturnCheckoutRoute
  '/link/$parentId/profil': typeof LinkParentIdProfilRoute
  '/admin/attendance': typeof AdminAttendanceIndexRoute
  '/admin/courses': typeof AdminCoursesIndexRoute
  '/admin/inscriptions': typeof AdminInscriptionsIndexRoute
  '/admin/invoices': typeof AdminInvoicesIndexRoute
  '/admin/new-enrollments': typeof AdminNewEnrollmentsIndexRoute
  '/admin/parents': typeof AdminParentsIndexRoute
  '/admin/payments': typeof AdminPaymentsIndexRoute
  '/admin/reminders': typeof AdminRemindersIndexRoute
  '/admin/sms': typeof AdminSmsIndexRoute
  '/admin/students': typeof AdminStudentsIndexRoute
  '/admin/teachers': typeof AdminTeachersIndexRoute
  '/link/$parentId': typeof LinkParentIdIndexRoute
  '/admin/invoices/correct/$id': typeof AdminInvoicesCorrectIdRoute
  '/link/$parentId/invoices/$invoiceId': typeof LinkParentIdInvoicesInvoiceIdRoute
  '/link/$parentId/payments/$paymentId': typeof LinkParentIdPaymentsPaymentIdRoute
  '/link/$parentId/invoices': typeof LinkParentIdInvoicesIndexRoute
  '/link/$parentId/payments': typeof LinkParentIdPaymentsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/facture': typeof FactureRouteRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/confirm-invitation': typeof ConfirmInvitationRoute
  '/connexion': typeof ConnexionRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/inscription': typeof InscriptionRoute
  '/inscription-stripe-unknown': typeof InscriptionStripeUnknownRoute
  '/inscription-success': typeof InscriptionSuccessRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify': typeof VerifyRoute
  '/admin/new-enrollments': typeof AdminNewEnrollmentsRouteRouteWithChildren
  '/admin/parents': typeof AdminParentsRouteRouteWithChildren
  '/admin/payments': typeof AdminPaymentsRouteRouteWithChildren
  '/admin/reminders': typeof AdminRemindersRouteRouteWithChildren
  '/admin/students': typeof AdminStudentsRouteRouteWithChildren
  '/facture/$invoiceId': typeof FactureInvoiceIdRoute
  '/link/$parentId': typeof LinkParentIdRouteWithChildren
  '/parent/$id': typeof ParentIdRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/configuration/cron-tasks': typeof AdminConfigurationCronTasksRoute
  '/admin/configuration/invitations': typeof AdminConfigurationInvitationsRoute
  '/admin/configuration/notifications': typeof AdminConfigurationNotificationsRoute
  '/admin/configuration/users': typeof AdminConfigurationUsersRoute
  '/admin/courses/$id': typeof AdminCoursesIdRoute
  '/admin/invoices/$id': typeof AdminInvoicesIdRoute
  '/admin/invoices/preview': typeof AdminInvoicesPreviewRoute
  '/admin/new-enrollments/$id': typeof AdminNewEnrollmentsIdRoute
  '/admin/parents/$id': typeof AdminParentsIdRoute
  '/admin/parents/import': typeof AdminParentsImportRoute
  '/admin/payments/$id': typeof AdminPaymentsIdRoute
  '/admin/students/$id': typeof AdminStudentsIdRoute
  '/admin/teachers/$id': typeof AdminTeachersIdRoute
  '/link/$parentId/invoices': typeof LinkParentIdInvoicesRouteWithChildren
  '/link/$parentId/pay': typeof LinkParentIdPayRoute
  '/link/$parentId/payment-methods': typeof LinkParentIdPaymentMethodsRoute
  '/link/$parentId/payment-return-checkout': typeof LinkParentIdPaymentReturnCheckoutRoute
  '/link/$parentId/payments': typeof LinkParentIdPaymentsRouteWithChildren
  '/link/$parentId/profil': typeof LinkParentIdProfilRoute
  '/admin/attendance/': typeof AdminAttendanceIndexRoute
  '/admin/courses/': typeof AdminCoursesIndexRoute
  '/admin/inscriptions/': typeof AdminInscriptionsIndexRoute
  '/admin/invoices/': typeof AdminInvoicesIndexRoute
  '/admin/new-enrollments/': typeof AdminNewEnrollmentsIndexRoute
  '/admin/parents/': typeof AdminParentsIndexRoute
  '/admin/payments/': typeof AdminPaymentsIndexRoute
  '/admin/reminders/': typeof AdminRemindersIndexRoute
  '/admin/sms/': typeof AdminSmsIndexRoute
  '/admin/students/': typeof AdminStudentsIndexRoute
  '/admin/teachers/': typeof AdminTeachersIndexRoute
  '/link/$parentId/': typeof LinkParentIdIndexRoute
  '/admin/invoices/correct/$id': typeof AdminInvoicesCorrectIdRoute
  '/link/$parentId/invoices/$invoiceId': typeof LinkParentIdInvoicesInvoiceIdRoute
  '/link/$parentId/payments/$paymentId': typeof LinkParentIdPaymentsPaymentIdRoute
  '/link/$parentId/invoices/': typeof LinkParentIdInvoicesIndexRoute
  '/link/$parentId/payments/': typeof LinkParentIdPaymentsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/facture'
    | '/admin'
    | '/confirm-invitation'
    | '/connexion'
    | '/forgot-password'
    | '/inscription'
    | '/inscription-stripe-unknown'
    | '/inscription-success'
    | '/login'
    | '/reset-password'
    | '/verify'
    | '/admin/new-enrollments'
    | '/admin/parents'
    | '/admin/payments'
    | '/admin/reminders'
    | '/admin/students'
    | '/facture/$invoiceId'
    | '/link/$parentId'
    | '/parent/$id'
    | '/admin/'
    | '/admin/configuration/cron-tasks'
    | '/admin/configuration/invitations'
    | '/admin/configuration/notifications'
    | '/admin/configuration/users'
    | '/admin/courses/$id'
    | '/admin/invoices/$id'
    | '/admin/invoices/preview'
    | '/admin/new-enrollments/$id'
    | '/admin/parents/$id'
    | '/admin/parents/import'
    | '/admin/payments/$id'
    | '/admin/students/$id'
    | '/admin/teachers/$id'
    | '/link/$parentId/invoices'
    | '/link/$parentId/pay'
    | '/link/$parentId/payment-methods'
    | '/link/$parentId/payment-return-checkout'
    | '/link/$parentId/payments'
    | '/link/$parentId/profil'
    | '/admin/attendance'
    | '/admin/courses'
    | '/admin/inscriptions'
    | '/admin/invoices'
    | '/admin/new-enrollments/'
    | '/admin/parents/'
    | '/admin/payments/'
    | '/admin/reminders/'
    | '/admin/sms'
    | '/admin/students/'
    | '/admin/teachers'
    | '/link/$parentId/'
    | '/admin/invoices/correct/$id'
    | '/link/$parentId/invoices/$invoiceId'
    | '/link/$parentId/payments/$paymentId'
    | '/link/$parentId/invoices/'
    | '/link/$parentId/payments/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/facture'
    | '/confirm-invitation'
    | '/connexion'
    | '/forgot-password'
    | '/inscription'
    | '/inscription-stripe-unknown'
    | '/inscription-success'
    | '/login'
    | '/reset-password'
    | '/verify'
    | '/facture/$invoiceId'
    | '/parent/$id'
    | '/admin'
    | '/admin/configuration/cron-tasks'
    | '/admin/configuration/invitations'
    | '/admin/configuration/notifications'
    | '/admin/configuration/users'
    | '/admin/courses/$id'
    | '/admin/invoices/$id'
    | '/admin/invoices/preview'
    | '/admin/new-enrollments/$id'
    | '/admin/parents/$id'
    | '/admin/parents/import'
    | '/admin/payments/$id'
    | '/admin/students/$id'
    | '/admin/teachers/$id'
    | '/link/$parentId/pay'
    | '/link/$parentId/payment-methods'
    | '/link/$parentId/payment-return-checkout'
    | '/link/$parentId/profil'
    | '/admin/attendance'
    | '/admin/courses'
    | '/admin/inscriptions'
    | '/admin/invoices'
    | '/admin/new-enrollments'
    | '/admin/parents'
    | '/admin/payments'
    | '/admin/reminders'
    | '/admin/sms'
    | '/admin/students'
    | '/admin/teachers'
    | '/link/$parentId'
    | '/admin/invoices/correct/$id'
    | '/link/$parentId/invoices/$invoiceId'
    | '/link/$parentId/payments/$paymentId'
    | '/link/$parentId/invoices'
    | '/link/$parentId/payments'
  id:
    | '__root__'
    | '/'
    | '/facture'
    | '/admin'
    | '/confirm-invitation'
    | '/connexion'
    | '/forgot-password'
    | '/inscription'
    | '/inscription-stripe-unknown'
    | '/inscription-success'
    | '/login'
    | '/reset-password'
    | '/verify'
    | '/admin/new-enrollments'
    | '/admin/parents'
    | '/admin/payments'
    | '/admin/reminders'
    | '/admin/students'
    | '/facture/$invoiceId'
    | '/link/$parentId'
    | '/parent/$id'
    | '/admin/'
    | '/admin/configuration/cron-tasks'
    | '/admin/configuration/invitations'
    | '/admin/configuration/notifications'
    | '/admin/configuration/users'
    | '/admin/courses/$id'
    | '/admin/invoices/$id'
    | '/admin/invoices/preview'
    | '/admin/new-enrollments/$id'
    | '/admin/parents/$id'
    | '/admin/parents/import'
    | '/admin/payments/$id'
    | '/admin/students/$id'
    | '/admin/teachers/$id'
    | '/link/$parentId/invoices'
    | '/link/$parentId/pay'
    | '/link/$parentId/payment-methods'
    | '/link/$parentId/payment-return-checkout'
    | '/link/$parentId/payments'
    | '/link/$parentId/profil'
    | '/admin/attendance/'
    | '/admin/courses/'
    | '/admin/inscriptions/'
    | '/admin/invoices/'
    | '/admin/new-enrollments/'
    | '/admin/parents/'
    | '/admin/payments/'
    | '/admin/reminders/'
    | '/admin/sms/'
    | '/admin/students/'
    | '/admin/teachers/'
    | '/link/$parentId/'
    | '/admin/invoices/correct/$id'
    | '/link/$parentId/invoices/$invoiceId'
    | '/link/$parentId/payments/$paymentId'
    | '/link/$parentId/invoices/'
    | '/link/$parentId/payments/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  FactureRouteRoute: typeof FactureRouteRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  ConfirmInvitationRoute: typeof ConfirmInvitationRoute
  ConnexionRoute: typeof ConnexionRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  InscriptionRoute: typeof InscriptionRoute
  InscriptionStripeUnknownRoute: typeof InscriptionStripeUnknownRoute
  InscriptionSuccessRoute: typeof InscriptionSuccessRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  VerifyRoute: typeof VerifyRoute
  LinkParentIdRoute: typeof LinkParentIdRouteWithChildren
  ParentIdRoute: typeof ParentIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inscription-success': {
      id: '/inscription-success'
      path: '/inscription-success'
      fullPath: '/inscription-success'
      preLoaderRoute: typeof InscriptionSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inscription-stripe-unknown': {
      id: '/inscription-stripe-unknown'
      path: '/inscription-stripe-unknown'
      fullPath: '/inscription-stripe-unknown'
      preLoaderRoute: typeof InscriptionStripeUnknownRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inscription': {
      id: '/inscription'
      path: '/inscription'
      fullPath: '/inscription'
      preLoaderRoute: typeof InscriptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connexion': {
      id: '/connexion'
      path: '/connexion'
      fullPath: '/connexion'
      preLoaderRoute: typeof ConnexionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirm-invitation': {
      id: '/confirm-invitation'
      path: '/confirm-invitation'
      fullPath: '/confirm-invitation'
      preLoaderRoute: typeof ConfirmInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/facture': {
      id: '/facture'
      path: '/facture'
      fullPath: '/facture'
      preLoaderRoute: typeof FactureRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/parent/$id': {
      id: '/parent/$id'
      path: '/parent/$id'
      fullPath: '/parent/$id'
      preLoaderRoute: typeof ParentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/link/$parentId': {
      id: '/link/$parentId'
      path: '/link/$parentId'
      fullPath: '/link/$parentId'
      preLoaderRoute: typeof LinkParentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/facture/$invoiceId': {
      id: '/facture/$invoiceId'
      path: '/$invoiceId'
      fullPath: '/facture/$invoiceId'
      preLoaderRoute: typeof FactureInvoiceIdRouteImport
      parentRoute: typeof FactureRouteRoute
    }
    '/admin/students': {
      id: '/admin/students'
      path: '/students'
      fullPath: '/admin/students'
      preLoaderRoute: typeof AdminStudentsRouteRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reminders': {
      id: '/admin/reminders'
      path: '/reminders'
      fullPath: '/admin/reminders'
      preLoaderRoute: typeof AdminRemindersRouteRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/payments': {
      id: '/admin/payments'
      path: '/payments'
      fullPath: '/admin/payments'
      preLoaderRoute: typeof AdminPaymentsRouteRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/parents': {
      id: '/admin/parents'
      path: '/parents'
      fullPath: '/admin/parents'
      preLoaderRoute: typeof AdminParentsRouteRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/new-enrollments': {
      id: '/admin/new-enrollments'
      path: '/new-enrollments'
      fullPath: '/admin/new-enrollments'
      preLoaderRoute: typeof AdminNewEnrollmentsRouteRouteImport
      parentRoute: typeof AdminRoute
    }
    '/link/$parentId/': {
      id: '/link/$parentId/'
      path: '/'
      fullPath: '/link/$parentId/'
      preLoaderRoute: typeof LinkParentIdIndexRouteImport
      parentRoute: typeof LinkParentIdRoute
    }
    '/admin/teachers/': {
      id: '/admin/teachers/'
      path: '/teachers'
      fullPath: '/admin/teachers'
      preLoaderRoute: typeof AdminTeachersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/students/': {
      id: '/admin/students/'
      path: '/'
      fullPath: '/admin/students/'
      preLoaderRoute: typeof AdminStudentsIndexRouteImport
      parentRoute: typeof AdminStudentsRouteRoute
    }
    '/admin/sms/': {
      id: '/admin/sms/'
      path: '/sms'
      fullPath: '/admin/sms'
      preLoaderRoute: typeof AdminSmsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reminders/': {
      id: '/admin/reminders/'
      path: '/'
      fullPath: '/admin/reminders/'
      preLoaderRoute: typeof AdminRemindersIndexRouteImport
      parentRoute: typeof AdminRemindersRouteRoute
    }
    '/admin/payments/': {
      id: '/admin/payments/'
      path: '/'
      fullPath: '/admin/payments/'
      preLoaderRoute: typeof AdminPaymentsIndexRouteImport
      parentRoute: typeof AdminPaymentsRouteRoute
    }
    '/admin/parents/': {
      id: '/admin/parents/'
      path: '/'
      fullPath: '/admin/parents/'
      preLoaderRoute: typeof AdminParentsIndexRouteImport
      parentRoute: typeof AdminParentsRouteRoute
    }
    '/admin/new-enrollments/': {
      id: '/admin/new-enrollments/'
      path: '/'
      fullPath: '/admin/new-enrollments/'
      preLoaderRoute: typeof AdminNewEnrollmentsIndexRouteImport
      parentRoute: typeof AdminNewEnrollmentsRouteRoute
    }
    '/admin/invoices/': {
      id: '/admin/invoices/'
      path: '/invoices'
      fullPath: '/admin/invoices'
      preLoaderRoute: typeof AdminInvoicesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/inscriptions/': {
      id: '/admin/inscriptions/'
      path: '/inscriptions'
      fullPath: '/admin/inscriptions'
      preLoaderRoute: typeof AdminInscriptionsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/courses/': {
      id: '/admin/courses/'
      path: '/courses'
      fullPath: '/admin/courses'
      preLoaderRoute: typeof AdminCoursesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/attendance/': {
      id: '/admin/attendance/'
      path: '/attendance'
      fullPath: '/admin/attendance'
      preLoaderRoute: typeof AdminAttendanceIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/link/$parentId/profil': {
      id: '/link/$parentId/profil'
      path: '/profil'
      fullPath: '/link/$parentId/profil'
      preLoaderRoute: typeof LinkParentIdProfilRouteImport
      parentRoute: typeof LinkParentIdRoute
    }
    '/link/$parentId/payments': {
      id: '/link/$parentId/payments'
      path: '/payments'
      fullPath: '/link/$parentId/payments'
      preLoaderRoute: typeof LinkParentIdPaymentsRouteImport
      parentRoute: typeof LinkParentIdRoute
    }
    '/link/$parentId/payment-return-checkout': {
      id: '/link/$parentId/payment-return-checkout'
      path: '/payment-return-checkout'
      fullPath: '/link/$parentId/payment-return-checkout'
      preLoaderRoute: typeof LinkParentIdPaymentReturnCheckoutRouteImport
      parentRoute: typeof LinkParentIdRoute
    }
    '/link/$parentId/payment-methods': {
      id: '/link/$parentId/payment-methods'
      path: '/payment-methods'
      fullPath: '/link/$parentId/payment-methods'
      preLoaderRoute: typeof LinkParentIdPaymentMethodsRouteImport
      parentRoute: typeof LinkParentIdRoute
    }
    '/link/$parentId/pay': {
      id: '/link/$parentId/pay'
      path: '/pay'
      fullPath: '/link/$parentId/pay'
      preLoaderRoute: typeof LinkParentIdPayRouteImport
      parentRoute: typeof LinkParentIdRoute
    }
    '/link/$parentId/invoices': {
      id: '/link/$parentId/invoices'
      path: '/invoices'
      fullPath: '/link/$parentId/invoices'
      preLoaderRoute: typeof LinkParentIdInvoicesRouteImport
      parentRoute: typeof LinkParentIdRoute
    }
    '/admin/teachers/$id': {
      id: '/admin/teachers/$id'
      path: '/teachers/$id'
      fullPath: '/admin/teachers/$id'
      preLoaderRoute: typeof AdminTeachersIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/students/$id': {
      id: '/admin/students/$id'
      path: '/$id'
      fullPath: '/admin/students/$id'
      preLoaderRoute: typeof AdminStudentsIdRouteImport
      parentRoute: typeof AdminStudentsRouteRoute
    }
    '/admin/payments/$id': {
      id: '/admin/payments/$id'
      path: '/$id'
      fullPath: '/admin/payments/$id'
      preLoaderRoute: typeof AdminPaymentsIdRouteImport
      parentRoute: typeof AdminPaymentsRouteRoute
    }
    '/admin/parents/import': {
      id: '/admin/parents/import'
      path: '/import'
      fullPath: '/admin/parents/import'
      preLoaderRoute: typeof AdminParentsImportRouteImport
      parentRoute: typeof AdminParentsRouteRoute
    }
    '/admin/parents/$id': {
      id: '/admin/parents/$id'
      path: '/$id'
      fullPath: '/admin/parents/$id'
      preLoaderRoute: typeof AdminParentsIdRouteImport
      parentRoute: typeof AdminParentsRouteRoute
    }
    '/admin/new-enrollments/$id': {
      id: '/admin/new-enrollments/$id'
      path: '/$id'
      fullPath: '/admin/new-enrollments/$id'
      preLoaderRoute: typeof AdminNewEnrollmentsIdRouteImport
      parentRoute: typeof AdminNewEnrollmentsRouteRoute
    }
    '/admin/invoices/preview': {
      id: '/admin/invoices/preview'
      path: '/invoices/preview'
      fullPath: '/admin/invoices/preview'
      preLoaderRoute: typeof AdminInvoicesPreviewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/invoices/$id': {
      id: '/admin/invoices/$id'
      path: '/invoices/$id'
      fullPath: '/admin/invoices/$id'
      preLoaderRoute: typeof AdminInvoicesIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/courses/$id': {
      id: '/admin/courses/$id'
      path: '/courses/$id'
      fullPath: '/admin/courses/$id'
      preLoaderRoute: typeof AdminCoursesIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/configuration/users': {
      id: '/admin/configuration/users'
      path: '/configuration/users'
      fullPath: '/admin/configuration/users'
      preLoaderRoute: typeof AdminConfigurationUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/configuration/notifications': {
      id: '/admin/configuration/notifications'
      path: '/configuration/notifications'
      fullPath: '/admin/configuration/notifications'
      preLoaderRoute: typeof AdminConfigurationNotificationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/configuration/invitations': {
      id: '/admin/configuration/invitations'
      path: '/configuration/invitations'
      fullPath: '/admin/configuration/invitations'
      preLoaderRoute: typeof AdminConfigurationInvitationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/configuration/cron-tasks': {
      id: '/admin/configuration/cron-tasks'
      path: '/configuration/cron-tasks'
      fullPath: '/admin/configuration/cron-tasks'
      preLoaderRoute: typeof AdminConfigurationCronTasksRouteImport
      parentRoute: typeof AdminRoute
    }
    '/link/$parentId/payments/': {
      id: '/link/$parentId/payments/'
      path: '/'
      fullPath: '/link/$parentId/payments/'
      preLoaderRoute: typeof LinkParentIdPaymentsIndexRouteImport
      parentRoute: typeof LinkParentIdPaymentsRoute
    }
    '/link/$parentId/invoices/': {
      id: '/link/$parentId/invoices/'
      path: '/'
      fullPath: '/link/$parentId/invoices/'
      preLoaderRoute: typeof LinkParentIdInvoicesIndexRouteImport
      parentRoute: typeof LinkParentIdInvoicesRoute
    }
    '/link/$parentId/payments/$paymentId': {
      id: '/link/$parentId/payments/$paymentId'
      path: '/$paymentId'
      fullPath: '/link/$parentId/payments/$paymentId'
      preLoaderRoute: typeof LinkParentIdPaymentsPaymentIdRouteImport
      parentRoute: typeof LinkParentIdPaymentsRoute
    }
    '/link/$parentId/invoices/$invoiceId': {
      id: '/link/$parentId/invoices/$invoiceId'
      path: '/$invoiceId'
      fullPath: '/link/$parentId/invoices/$invoiceId'
      preLoaderRoute: typeof LinkParentIdInvoicesInvoiceIdRouteImport
      parentRoute: typeof LinkParentIdInvoicesRoute
    }
    '/admin/invoices/correct/$id': {
      id: '/admin/invoices/correct/$id'
      path: '/invoices/correct/$id'
      fullPath: '/admin/invoices/correct/$id'
      preLoaderRoute: typeof AdminInvoicesCorrectIdRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface FactureRouteRouteChildren {
  FactureInvoiceIdRoute: typeof FactureInvoiceIdRoute
}

const FactureRouteRouteChildren: FactureRouteRouteChildren = {
  FactureInvoiceIdRoute: FactureInvoiceIdRoute,
}

const FactureRouteRouteWithChildren = FactureRouteRoute._addFileChildren(
  FactureRouteRouteChildren,
)

interface AdminNewEnrollmentsRouteRouteChildren {
  AdminNewEnrollmentsIdRoute: typeof AdminNewEnrollmentsIdRoute
  AdminNewEnrollmentsIndexRoute: typeof AdminNewEnrollmentsIndexRoute
}

const AdminNewEnrollmentsRouteRouteChildren: AdminNewEnrollmentsRouteRouteChildren =
  {
    AdminNewEnrollmentsIdRoute: AdminNewEnrollmentsIdRoute,
    AdminNewEnrollmentsIndexRoute: AdminNewEnrollmentsIndexRoute,
  }

const AdminNewEnrollmentsRouteRouteWithChildren =
  AdminNewEnrollmentsRouteRoute._addFileChildren(
    AdminNewEnrollmentsRouteRouteChildren,
  )

interface AdminParentsRouteRouteChildren {
  AdminParentsIdRoute: typeof AdminParentsIdRoute
  AdminParentsImportRoute: typeof AdminParentsImportRoute
  AdminParentsIndexRoute: typeof AdminParentsIndexRoute
}

const AdminParentsRouteRouteChildren: AdminParentsRouteRouteChildren = {
  AdminParentsIdRoute: AdminParentsIdRoute,
  AdminParentsImportRoute: AdminParentsImportRoute,
  AdminParentsIndexRoute: AdminParentsIndexRoute,
}

const AdminParentsRouteRouteWithChildren =
  AdminParentsRouteRoute._addFileChildren(AdminParentsRouteRouteChildren)

interface AdminPaymentsRouteRouteChildren {
  AdminPaymentsIdRoute: typeof AdminPaymentsIdRoute
  AdminPaymentsIndexRoute: typeof AdminPaymentsIndexRoute
}

const AdminPaymentsRouteRouteChildren: AdminPaymentsRouteRouteChildren = {
  AdminPaymentsIdRoute: AdminPaymentsIdRoute,
  AdminPaymentsIndexRoute: AdminPaymentsIndexRoute,
}

const AdminPaymentsRouteRouteWithChildren =
  AdminPaymentsRouteRoute._addFileChildren(AdminPaymentsRouteRouteChildren)

interface AdminRemindersRouteRouteChildren {
  AdminRemindersIndexRoute: typeof AdminRemindersIndexRoute
}

const AdminRemindersRouteRouteChildren: AdminRemindersRouteRouteChildren = {
  AdminRemindersIndexRoute: AdminRemindersIndexRoute,
}

const AdminRemindersRouteRouteWithChildren =
  AdminRemindersRouteRoute._addFileChildren(AdminRemindersRouteRouteChildren)

interface AdminStudentsRouteRouteChildren {
  AdminStudentsIdRoute: typeof AdminStudentsIdRoute
  AdminStudentsIndexRoute: typeof AdminStudentsIndexRoute
}

const AdminStudentsRouteRouteChildren: AdminStudentsRouteRouteChildren = {
  AdminStudentsIdRoute: AdminStudentsIdRoute,
  AdminStudentsIndexRoute: AdminStudentsIndexRoute,
}

const AdminStudentsRouteRouteWithChildren =
  AdminStudentsRouteRoute._addFileChildren(AdminStudentsRouteRouteChildren)

interface AdminRouteChildren {
  AdminNewEnrollmentsRouteRoute: typeof AdminNewEnrollmentsRouteRouteWithChildren
  AdminParentsRouteRoute: typeof AdminParentsRouteRouteWithChildren
  AdminPaymentsRouteRoute: typeof AdminPaymentsRouteRouteWithChildren
  AdminRemindersRouteRoute: typeof AdminRemindersRouteRouteWithChildren
  AdminStudentsRouteRoute: typeof AdminStudentsRouteRouteWithChildren
  AdminIndexRoute: typeof AdminIndexRoute
  AdminConfigurationCronTasksRoute: typeof AdminConfigurationCronTasksRoute
  AdminConfigurationInvitationsRoute: typeof AdminConfigurationInvitationsRoute
  AdminConfigurationNotificationsRoute: typeof AdminConfigurationNotificationsRoute
  AdminConfigurationUsersRoute: typeof AdminConfigurationUsersRoute
  AdminCoursesIdRoute: typeof AdminCoursesIdRoute
  AdminInvoicesIdRoute: typeof AdminInvoicesIdRoute
  AdminInvoicesPreviewRoute: typeof AdminInvoicesPreviewRoute
  AdminTeachersIdRoute: typeof AdminTeachersIdRoute
  AdminAttendanceIndexRoute: typeof AdminAttendanceIndexRoute
  AdminCoursesIndexRoute: typeof AdminCoursesIndexRoute
  AdminInscriptionsIndexRoute: typeof AdminInscriptionsIndexRoute
  AdminInvoicesIndexRoute: typeof AdminInvoicesIndexRoute
  AdminSmsIndexRoute: typeof AdminSmsIndexRoute
  AdminTeachersIndexRoute: typeof AdminTeachersIndexRoute
  AdminInvoicesCorrectIdRoute: typeof AdminInvoicesCorrectIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminNewEnrollmentsRouteRoute: AdminNewEnrollmentsRouteRouteWithChildren,
  AdminParentsRouteRoute: AdminParentsRouteRouteWithChildren,
  AdminPaymentsRouteRoute: AdminPaymentsRouteRouteWithChildren,
  AdminRemindersRouteRoute: AdminRemindersRouteRouteWithChildren,
  AdminStudentsRouteRoute: AdminStudentsRouteRouteWithChildren,
  AdminIndexRoute: AdminIndexRoute,
  AdminConfigurationCronTasksRoute: AdminConfigurationCronTasksRoute,
  AdminConfigurationInvitationsRoute: AdminConfigurationInvitationsRoute,
  AdminConfigurationNotificationsRoute: AdminConfigurationNotificationsRoute,
  AdminConfigurationUsersRoute: AdminConfigurationUsersRoute,
  AdminCoursesIdRoute: AdminCoursesIdRoute,
  AdminInvoicesIdRoute: AdminInvoicesIdRoute,
  AdminInvoicesPreviewRoute: AdminInvoicesPreviewRoute,
  AdminTeachersIdRoute: AdminTeachersIdRoute,
  AdminAttendanceIndexRoute: AdminAttendanceIndexRoute,
  AdminCoursesIndexRoute: AdminCoursesIndexRoute,
  AdminInscriptionsIndexRoute: AdminInscriptionsIndexRoute,
  AdminInvoicesIndexRoute: AdminInvoicesIndexRoute,
  AdminSmsIndexRoute: AdminSmsIndexRoute,
  AdminTeachersIndexRoute: AdminTeachersIndexRoute,
  AdminInvoicesCorrectIdRoute: AdminInvoicesCorrectIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface LinkParentIdInvoicesRouteChildren {
  LinkParentIdInvoicesInvoiceIdRoute: typeof LinkParentIdInvoicesInvoiceIdRoute
  LinkParentIdInvoicesIndexRoute: typeof LinkParentIdInvoicesIndexRoute
}

const LinkParentIdInvoicesRouteChildren: LinkParentIdInvoicesRouteChildren = {
  LinkParentIdInvoicesInvoiceIdRoute: LinkParentIdInvoicesInvoiceIdRoute,
  LinkParentIdInvoicesIndexRoute: LinkParentIdInvoicesIndexRoute,
}

const LinkParentIdInvoicesRouteWithChildren =
  LinkParentIdInvoicesRoute._addFileChildren(LinkParentIdInvoicesRouteChildren)

interface LinkParentIdPaymentsRouteChildren {
  LinkParentIdPaymentsPaymentIdRoute: typeof LinkParentIdPaymentsPaymentIdRoute
  LinkParentIdPaymentsIndexRoute: typeof LinkParentIdPaymentsIndexRoute
}

const LinkParentIdPaymentsRouteChildren: LinkParentIdPaymentsRouteChildren = {
  LinkParentIdPaymentsPaymentIdRoute: LinkParentIdPaymentsPaymentIdRoute,
  LinkParentIdPaymentsIndexRoute: LinkParentIdPaymentsIndexRoute,
}

const LinkParentIdPaymentsRouteWithChildren =
  LinkParentIdPaymentsRoute._addFileChildren(LinkParentIdPaymentsRouteChildren)

interface LinkParentIdRouteChildren {
  LinkParentIdInvoicesRoute: typeof LinkParentIdInvoicesRouteWithChildren
  LinkParentIdPayRoute: typeof LinkParentIdPayRoute
  LinkParentIdPaymentMethodsRoute: typeof LinkParentIdPaymentMethodsRoute
  LinkParentIdPaymentReturnCheckoutRoute: typeof LinkParentIdPaymentReturnCheckoutRoute
  LinkParentIdPaymentsRoute: typeof LinkParentIdPaymentsRouteWithChildren
  LinkParentIdProfilRoute: typeof LinkParentIdProfilRoute
  LinkParentIdIndexRoute: typeof LinkParentIdIndexRoute
}

const LinkParentIdRouteChildren: LinkParentIdRouteChildren = {
  LinkParentIdInvoicesRoute: LinkParentIdInvoicesRouteWithChildren,
  LinkParentIdPayRoute: LinkParentIdPayRoute,
  LinkParentIdPaymentMethodsRoute: LinkParentIdPaymentMethodsRoute,
  LinkParentIdPaymentReturnCheckoutRoute:
    LinkParentIdPaymentReturnCheckoutRoute,
  LinkParentIdPaymentsRoute: LinkParentIdPaymentsRouteWithChildren,
  LinkParentIdProfilRoute: LinkParentIdProfilRoute,
  LinkParentIdIndexRoute: LinkParentIdIndexRoute,
}

const LinkParentIdRouteWithChildren = LinkParentIdRoute._addFileChildren(
  LinkParentIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  FactureRouteRoute: FactureRouteRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  ConfirmInvitationRoute: ConfirmInvitationRoute,
  ConnexionRoute: ConnexionRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  InscriptionRoute: InscriptionRoute,
  InscriptionStripeUnknownRoute: InscriptionStripeUnknownRoute,
  InscriptionSuccessRoute: InscriptionSuccessRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  VerifyRoute: VerifyRoute,
  LinkParentIdRoute: LinkParentIdRouteWithChildren,
  ParentIdRoute: ParentIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
